import { HttpErrorResponse } from '@angular/common/http';
import { z } from 'zod';
import { ApiError } from '@shared/lib/errors/domain-errors';

const SlippageTooLowBodySchema = z.object({
  data: z.object({ requiredSlippageBps: z.number().int() }),
});

export function requiredSlippageFrom(e: unknown): number | null {
  if (!(e instanceof ApiError) || e.errorCode !== 'SLIPPAGE_TOO_LOW') return null;
  const body = e.cause instanceof HttpErrorResponse ? e.cause.error : null;
  const parsed = SlippageTooLowBodySchema.safeParse(body);
  return parsed.success ? parsed.data.data.requiredSlippageBps : null;
}
